import { employee, or, qantProductAdmin } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/**
 * Troppus (顧客データベース / ユーザーデータ基盤) のメニュー定義。
 * 出典: apps/troppus/packages/front/src/routes/__root.tsx (mainLinks)
 */
export const QANT_TROPPUS_MENU = {
  product: {
    name: 'troppus',
    icon: 'qantSupportDataHub',
    label: { ja: '顧客データベース', en: 'Customer Database' },
    description: { ja: 'ユーザーデータ基盤', en: 'User Data Platform' },
  },
  menuGroups: {
    BASIC: {
      name: 'basic',
      menus: {
        TABLE_DEFINITIONS: {
          name: 'tableDefinitions',
          icon: 'tableDefinition',
          label: { ja: 'テーブル定義', en: 'Table Definitions' },
          path: { host: 'qant', path: '/troppus/table-definitions' },
        },
        TASKS: {
          name: 'tasks',
          icon: 'taskList',
          label: { ja: 'タスク一覧', en: 'Tasks' },
          path: { host: 'qant', path: '/troppus/tasks' },
        },
        SETTINGS: {
          name: 'settings',
          icon: 'settings',
          label: { ja: '設定', en: 'Settings' },
          path: { host: 'qant', path: '/troppus/settings' },
          // v1: isProjectAdmin (group.policy.troppus.isAdmin) || isEmployee (usePermissions)
          condition: or(qantProductAdmin('troppus'), employee()),
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
